export default "__VITE_ASSET__BQ44ANBH__"